<template>
    <div class="info p-0">
        <div id="notification-bell"
             class="notification-bell m-0">
            <div class="info mx-0 p-0">
                <div v-for="notification in props.notifications"
                     :key="notification.title">
                    <a :href="notification.link"
                       data-category="menu-notification"
                       :target="notification.isExternal && '_blank'"
                       :rel="notification.isExternal && 'nofollow noindex noopener'"
                       @click="props.closeTippy">
                        <Notification :notification="notification" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import Notification from '../Notification.vue';
    import { NotificationType } from '../../types/types';

    interface Props {
        closeTippy?: () => void;
        notifications?: NotificationType[];
    }
    const props = withDefaults(defineProps<Props>(), {
        closeTippy: () => {},
        notifications: () => [],
    });
</script>

<style scoped lang="scss">
.notification-bell {
    display: flex;
}
</style>
